export function cardsSlider() {
    // const $cardsSlider = $(".cards-slider");
    // $cardsSlider.each(function (i, el) {
    //     $(el).slick({
    //         dots: false,
    //         arrows: false,
    //         infinite: true,
    //         speed: 300,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         mobileFirst: true,
    //         responsive: [
    //             {
    //                 breakpoint: 767,
    //                 settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 1,
    //                 }
    //             },
    //             {
    //                 breakpoint: 1023,
    //                 settings: {
    //                     slidesToShow: 3.1,
    //                     infinite: false,
    //                 }
    //             }, {
    //                 breakpoint: 1199,
    //                 settings: {
    //                     slidesToShow: 3.3,
    //                     infinite: false,
    //                     arrows: true
    //                 }
    //             },
    //         ]
    //     }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    //         let visibleSlides = slick.options.slidesToShow;
    //         let lastVisibleIndex = slick.slideCount - visibleSlides;
    //         if (nextSlide >= lastVisibleIndex) {
    //             $(el).addClass('last-slide');
    //         } else {
    //             $(el).removeClass('last-slide');
    //         }
    //     });
    // });
    const $cardsSlider = $(".cards-slider");

    function checkFewSlides($slider, slick) {
        const slidesToShow = slick.options.slidesToShow;
        const totalSlides = slick.slideCount;

        if (totalSlides <= slidesToShow) {
            $slider.addClass('few-slides');
        } else {
            $slider.removeClass('few-slides');
        }
    }

    $cardsSlider.each(function (i, el) {
        const $slider = $(el);

        $slider.slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3.1,
                        infinite: false,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3.3,
                        infinite: false,
                        arrows: true
                    }
                },
            ]
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const visibleSlides = slick.options.slidesToShow;
            const lastVisibleIndex = slick.slideCount - visibleSlides;
            if (nextSlide >= lastVisibleIndex) {
                $slider.addClass('last-slide');
            } else {
                $slider.removeClass('last-slide');
            }
        }).on('init', function (event, slick) {
            checkFewSlides($slider, slick);
        }).on('setPosition', function (event, slick) {
            checkFewSlides($slider, slick);
        });
    });

    let resizeTimeout;
    $(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            $cardsSlider.each(function (i, el) {
                const $slider = $(el);
                if ($slider.hasClass('slick-initialized')) {
                    const slickInstance = $slider.slick('getSlick');
                    checkFewSlides($slider, slickInstance);
                }
            });
        }, 300);
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/cardsSlider.js